import { render } from "./VideoButton.vue?vue&type=template&id=213a2029&scoped=true&ts=true&lang=pug"
import script from "./VideoButton.vue?vue&type=script&lang=ts"
export * from "./VideoButton.vue?vue&type=script&lang=ts"

import "./VideoButton.vue?vue&type=style&index=0&id=213a2029&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213a2029"]])

export default __exports__